module.exports = __webpack_public_path__ + "static/media/cedis.b260ec7b.svg";